import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

import { User } from '@commons/models/domain/User';
import { UserHttpService } from '@shared/services-http/user-http.service';

@Component({
  selector: 'app-account-data-form',
  templateUrl: './account-data-form.component.html',
  styleUrls: ['./account-data-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccountDataFormComponent implements OnInit {

  public form: FormGroup = new FormGroup({
    firstName: new FormControl(''),
    lastName: new FormControl(''),
    phone: new FormControl(''),
    email: new FormControl(''),
  });

  get user(): User | undefined {
    return this.userHttpService?.userViewModel?.user;
  }

  constructor(
    private userHttpService: UserHttpService,
  ) { }

  ngOnInit(): void {
    this.setData();
  }

  public setData(): void {
    this.form.patchValue({
      firstName: this.user?.FirstName,
      lastName: this.user?.LastName,
      phone: this.user?.Phone,
      email: this.user?.Email,
    });
    this.form.disable();
  }

}
